import { TemplateDataContext } from "providers/TemplateDataProvider/";
import { useContext } from "react";

export const useTemplateData = () => {
  const context = useContext(TemplateDataContext);
  if (!context) {
    throw new Error(
      "useTemplateData must be used within a TemplateDataProvider"
    );
  }
  return context;
};
